import React from 'react';
import * as R from 'ramda';
import {
  fetchCustomers,
  fetchUnauthorizedList,
  getStepThreeDisableContinue,
  getStepTwoDisableContinue,
  resetCarrierAuthWizardData,
  setHasUnsavedChanges,
} from '../store/createNewCarrierAuthSlice';

import Detail from './detail/Detail.connector';
import SelectLocationStep from './select-step/SelectLocationStep';
import SelectCustomers from './select-customers/SelectCustomers.connector';
import Summary from './summary/Summary.connector';
import Submit from './submit/Submit.connector';

const allCarrierAuthSteps = [
  {
    component: <Detail />,
    // optionally could pass a useSelector here instead
    disabled: store => {
      const { viewById } = store.loadingManagement.createNewCarrierAuth.params;
      return !viewById;
    },
    goNext: dispatch => dispatch(fetchUnauthorizedList()),
    hasChanges: store => store.loadingManagement.createNewCarrierAuth.hasUnsavedChanges,
    id: 1,
    leftLabel: 'Cancel',
    loading: R.F,
    rightLabel: 'Continue',
    showSpinner: store => store.loadingManagement.createNewCarrierAuth.unauthorizedListPending,
    stepLabel: R.always('Detail'),
  },
  {
    component: <SelectLocationStep />,
    disabled: store => getStepTwoDisableContinue(store),
    goBack: R.F,
    goNext: (dispatch, setCurrentStepIdx) => {
      dispatch(fetchCustomers());
      setCurrentStepIdx(R.inc);
      return true;
    },
    hasChanges: R.T,
    id: 2,
    leftLabel: 'Back',
    loading: R.F,
    rightLabel: 'Continue',
    showSpinner: R.F,
    stepLabel: store => {
      const { authorizationBy } = store.loadingManagement.createNewCarrierAuth;
      return authorizationBy === 'carrier' ? 'Locations' : 'Carriers';
    },
  },
  {
    component: <SelectCustomers />,
    disabled: store => getStepThreeDisableContinue(store),
    goBack: (_, setCurrentStepIdx) => setCurrentStepIdx(R.dec),
    goNext: (_, setCurrentStepIdx) => setCurrentStepIdx(R.inc),
    hasChanges: R.T,
    id: 3,
    leftLabel: 'Back',
    loading: R.F,
    rightLabel: 'Continue',
    showSpinner: R.F,
    stepLabel: R.always('Restrictions'),
  },
  {
    component: <Summary />,
    disabled: R.F,
    goBack: (_, setCurrentStepIdx) => setCurrentStepIdx(R.dec),
    goNext: (dispatch, setCurrentStepIdx) => {
      dispatch(setHasUnsavedChanges(false));
      setCurrentStepIdx(R.inc);
    },
    hasChanges: R.T,
    id: 4,
    leftLabel: 'Back',
    loading: R.F,
    rightLabel: 'Submit',
    showSpinner: R.F,
    stepLabel: R.always('Summary'),
  },
  {
    component: <Submit />,
    disabled: store => store.loadingManagement.createNewCarrierAuth.submittingBatch,
    goBack: (dispatchEvent, setCurrentStepIdx) => {
      dispatchEvent(resetCarrierAuthWizardData());
      setCurrentStepIdx(0);
      return true;
    },
    goNext: R.always(),
    hasChanges: R.F,
    id: 5,
    leftLabel: 'Create New',
    loading: R.F,
    rightLabel: 'Done',
    showSpinner: R.F,
    stepLabel: R.always('Progress'),
  },
];

export default allCarrierAuthSteps;
